import { ClassesType } from 'isolated-design-library'
import { CubesIcon, Grid, Theme, Typography, createStyles, useHeader, withStyles } from '@forgeglobal/design-framework'
import React from 'react'

const styles = (theme: Theme) =>
  createStyles({
    wrapper: {
      minHeight: '100%',
      textAlign: 'center',
      opacity: 0.7,
      display: 'flex',
    },
    icon: {
      fontSize: 120,
      opacity: 0.2,
    },
  })

const _WorkInProgress = ({ classes }: { classes: ClassesType<typeof styles> }) => {
  useHeader()
  return (
    <Grid container className={classes.wrapper} alignContent="center" alignItems="center" justify="center">
      <Grid item>
        <CubesIcon className={classes.icon} />
        <Typography variant="subtitle2">This page is in progress.</Typography>
      </Grid>
    </Grid>
  )
}

export const WorkInProgress = withStyles(styles)(_WorkInProgress)
